const sheRunsWith = document.querySelector('.she-runs-with');

if (sheRunsWith) {
  const toggleButton = sheRunsWith.querySelector('.she-runs-with__toggle');
  const overlay = sheRunsWith.querySelector('.she-runs-with__overlay');
  let lastFocusedElement;

  const closeOverlay = () => {
    sheRunsWith.classList.remove('is-items-open');
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.setAttribute('aria-label', '森川千明の着用アイテムを見る');
    overlay.setAttribute('aria-hidden', 'true');
    lastFocusedElement?.focus();
  };

  toggleButton.addEventListener('click', () => {
    if (sheRunsWith.classList.contains('is-items-open')) {
      closeOverlay();
      return;
    }

    lastFocusedElement = document.activeElement;
    sheRunsWith.classList.add('is-items-open');
    toggleButton.setAttribute('aria-expanded', 'true');
    toggleButton.setAttribute('aria-label', '着用アイテム表示を閉じる');
    overlay.setAttribute('aria-hidden', 'false');
  });

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeOverlay();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sheRunsWith.classList.contains('is-items-open')) closeOverlay();
  });
}
